import type {
    FC
} from "react";
import type ICommandLoadingProps from "./type";

const CommandLoading: FC<ICommandLoadingProps> = () => {
    return null;
};
export default Object.assign(CommandLoading, {
    commandPart: "loading"
});
